/*
 * Access point for npm.
 */

'use strict';

const CanvasSequence = require('./src/CanvasSequence.js');
const CanvasBlueprint = require('./src/CanvasBlueprint.js');

module.exports = { CanvasSequence, CanvasBlueprint };

